<template lang="pug">
.wrapper(class="slideWrapper")
  #powerbi(style="margin-top: 80px;border:none;margin-left: 70px;width: calc(100vw - 70px);height: calc(100vh - 80px);")
</template>
<script>
import {
    mapState
} from 'vuex';
import * as pbi from 'powerbi-client';
const axios = require('axios')
const FormData = require('form-data');
const clientconfig = require('@/client.json');
export default {
    name: 'home',
    bodyClass: 'powerbi',
    computed: {
        ...mapState({
            username: 'user'
        }),
        spinner: {
            get: function () {
                return this.$store.getters.get('spinner');
            },
            set: function (val) {
                this.$store.commit('change', {
                    spinner: val
                })
            }
        },
    },
    data() {
        return {
            token: undefined
        }
    },

    beforeMount() {
    },
    mounted() {
        this.spinner = true;
        async function getEmbed2() {
            try {
        const tokenData = {
            'grant_type': 'client_credentials',
            'client_id': clientconfig.clientId,
            'client_secret': clientconfig.clientSecret,
            'resource': 'https://analysis.windows.net/powerbi/api/.default'
        }
        const form = new FormData();
        let w = this;
        let request = Object.keys(tokenData).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(tokenData[k])}`).join('&')
                const tokenR = await axios.post('https://login.microsoftonline.com/61694941-f649-4b38-b96f-0ccdfdc0fc56/oauth2/v2.0/token', request, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                console.log(tokenR.data['access_token'])
                const authToken = tokenR.data['access_token']
                const options = {
                    headers: {
                        'Content-type': 'application/json',
                        'Authorization': 'Bearer ' + authToken
                    }
                }
                let body = {
                    "accessLevel": "View",
                    "allowSaveAs": "true"
                }
                let embedurl = await axios.post('https://api.powerbi.com/v1.0/myorg/groups/ecd2f991-cb0b-4544-ad67-0b67fa6ff3f8/reports/1f6c57e7-e7fc-4eff-94a8-409d78890cbe/generateToken', body, options)
                this.token = embedurl && embedurl.data && embedurl.data.tokenId ? embedurl.data.tokenId : false
            } catch (err) {
                console.log(err);
            }
        }
        getEmbed2()
        /*
        let url = "https://asiaaltfunctions.azurewebsites.net/api/gettoken?code=" + clientconfig.code;
        console.log(url);
        //let url = "https://asiaaltpowerbi.azurewebsites.net/api/getToken?code=0X2lMP7vpeVIjI56mRQn804dQrDoreyHrGwJcUaXwixJAzFu3SLCFg=="
        const tokenData = {
            'grant_type': 'client_credentials',
            'client_id': clientconfig.clientId,
            'client_secret': clientconfig.clientSecret,
            'resource': 'https://analysis.windows.net/powerbi/api/.default'
        }
        const form = new FormData();
        let w = this;
        let request = Object.keys(tokenData).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(tokenData[k])}`).join('&')
        async function getEmbed() {
            try {
                console.log('getting')
                const embedurl = await axios.post(url, {}, {
                    headers: {
                        'Content-type': 'application/json'
                    }
                })
                console.log('got', embedurl)
                w.token = embedurl && embedurl.data ? embedurl.data.token : false
            } catch (err) {
                console.log(err);
                w.spinner = false;
            }
            var permissions = pbi.models.Permissions.All
            const config = {
                type: 'report',
                tokenType: pbi.models.TokenType.Embed,
                accessToken: w.token,
                embedUrl: 'https://app.powerbi.com/reportEmbed',
                id: "1f6c57e7-e7fc-4eff-94a8-409d78890cbe",
                pageView: 'fitToWidth',
                permissions: permissions,
            };
            if (w.token) {
                let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
                var reportContainer = document.getElementById('powerbi');
                var report = powerbi.embed(reportContainer, config);
                w.spinner = false;
                report.off("loaded");
                report.off("rendered");
                report.on("error", function(err) {
                    console.log(err)
                w.spinner = false;
                    this.report.off("error");
                });
            }
        }
        getEmbed()
        */
    },
    methods: {
        showSignUp: function() {
            console.log('Request Access Modal')
        }
    }
}
</script>
<style>
body.presentation-page {}

.presentation-page #app .page-header-city,
.index-page .page-header-city {
    top: 15.5%;
}

body.presentation-page .h3-description.rellax-text {
    font-size: 2.5em;
}

body.presentation-page #app .rellax-text-container,
.index-page .rellax-text-container {
    top: 150px;
}

.presentation-page #app .rellax-text-container .h1-seo,
#app .index-page .rellax-text-container .h1-seo {
    text-transform: lowercase;
    background: #19405c;
    -webkit-text-stroke: 1px #d6cfcf
}

.presentation-page #app .subtext .h3-description,
.index-page .h3-description {
    display: inline-block;
    position: relative;
    margin-top: 100px;
    /*background-color: rgba(50,0,0,0.2);*/
    padding: 10px 12px;
    border-radius: 50px;
    opacity: 1;
    -webkit-transition: opacity 0.5s;
    transition: opacity 0.5s;
    width: auto;
    text-align: center;
    /*box-shadow: 0 5px 35px 0 rgba(0,0,0,.3);
    text-shadow: -5px 0px 20px rgba(50, 0, 0, 0.5), 5px 0px 20px rgba(50, 0, 0, 0.5), 0 -5px 20px rgba(50, 0, 0, 0.5), 0 5px 20px rgba(50, 0, 0, 0.5);*/
}

.presentation-page #app.scrolled .h3-description {
    opacity: 0;
}

#app .subtext {
    width: 100%;
    text-align: center;
}

#app .rellax-text-container {
    opacity: 1;
    transition: opacity 0.75s;
}

#app.scrolled .rellax-text-container {
    opacity: 0;
}

.signUp {
    position: relative;
    z-index: 10;
    text-align: center;
    width: 100%;
    margin-top: -20px;
    transition: opacity 0.75s;
}

.presentation-page #app.scrolled .signUp {
    opacity: 0;
}

.presentation-page #app .signUp a.btn.btn-primary {
    width: 100px;
    display: inline-block;
    height: 46px;
    color: white;
    border: 2px solid rgba(255, 255, 255, 1);
    padding: 9px 0px;
    top: 50%;
    border-radius: 50px;
}

.presentation-page #app .signUp a:active,
.presentation-page #app .signUp a:hover {
    border: 2px solid rgb(255, 255, 255);
}

.index-page .page-header,
.presentation-page .page-header {
    height: 100vh;
}

.presentation-page #app .page-header .content-center.frame {
    max-width: 1100px;
    position: relative;
    top: 100px;
    transform: translate(-50%)
}

#powerbi iframe {
    border: none;
}
body.powerbi .wrapper {
height: unset;
}

body.powerbi #app #page {
    background: white;
}
</style>
